define("preview-grid/components/post-schedule-sidebar", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cPV--listPanel {{if this.hasEditedPosts 'has--changes' ''}}">
    <ul class="u--listUnstyle">
      <li class="cPV--list__li u--text--left">
        {{#if @enableAutoSchedule}}
          <p class="u--text--bold" data-test-id="postScheduleTitle">
            {{t "preview_grid.post_schedule"}}
          </p>
          {{#if @isFeedTab}}
            <p class="u--text--sm u--m__0" data-test-id="dragMediaMessage">
              {{t "preview_grid.can_schedule_message"}}
            </p>
          {{else if @isReelsTab}}
            <div class="cIC--card">
              <div class="cIC--cardBody u--p__sm">
                {{t "preview_grid.reels.can_schedule_message"}}
                <LinkTo @route="index">
                  {{t "preview_grid.reels.can_schedule_message_action"}}
                </LinkTo>
              </div>
            </div>
          {{/if}}
        {{else if this.canCreateTimeSlots}}
          <p class="u--text--bold">
            {{t "preview_grid.setup_quick_schedule_title"}}
          </p>
          <p class="u--text--sm u--m__b">
            {{t "preview_grid.setup_quick_schedule_info"}}
          </p>
          <Shared::Ui::Button
            @additional="block"
            @onClick={{@showQuickScheduleWizard}}
            @text={{t "preview_grid.setup_quick_schedule"}}
            @variant="outline"
            data-test-id="quickScheduleButton"
          />
        {{else}}
          <p class="u--text--bold" data-test-id="previewGridTitle">
            {{t "preview_grid.preview_posts"}}
          </p>
          <p class="u--text--sm u--m__0" data-test-id="cannotScheduleMsg">
            {{t "preview_grid.cannot_schedule_message"}}
          </p>
        {{/if}}
      </li>
      {{#if this.hasEditablePosts}}
        {{#each this.sortedEditablePosts as |post|}}
          <li class="cPV--list__li {{if post.hasBeenEdited 'has--changes' ''}}">
            <img class="cPV--list__img u--inline" src={{post.secureImageUrl}} />
            {{#if post.isDraftPost}}
              <span class="cPV--list__label--draft">
                {{svg-jar "draft-post" class="o--icon--sm"}}
                {{t "shared_words.draft"}}
              </span>
            {{/if}}
            <div class="cPV--list__content">
              {{#if post.isRemoved}}
                <div class="cPV--list__undo">
                  <span class="u--text--light u--text--sm">
                    {{t "preview_grid.post_unscheduled"}}
                  </span>
                  <Shared::Ui::Button
                    @class="u--text--sm u--text--uppercase u--p__r__0 u--text--hl"
                    @onClick={{fn this.undoRemovePreviewPost post}}
                    @variant="unstyled"
                  >
                    {{svg-jar "undo" class="o--icon"}}
                    <EmberTooltip @delay={{330}} @side="left">
                      <span>{{t "preview_grid.undo"}}</span>
                    </EmberTooltip>
                  </Shared::Ui::Button>
                </div>
              {{else if post.hasScheduledTime}}
                <span class="u--block u--text--sm">
                  {{moment-format post.scheduledMoment "MMM DD h:mm a, YYYY" this.timeZoneIdentifier}}
                </span>
                {{#unless post.socialProfile.hasPublishingMethod}}
                  <span class="u--block u--text--sm">{{t "preview_grid.non_published_post"}}</span>
                {{/unless}}
              {{else}}
                <span class="u--block u--text--sm">{{t "preview_grid.to_be_auto_scheduled"}}</span>
              {{/if}}
            </div>
          </li>
        {{/each}}
      {{else}}
        <div class="o--blank">
          <p data-test-id="noScheduledPostsMsg">
            {{t "preview_grid.empty_list"}}
          </p>
        </div>
      {{/if}}
    </ul>
  </div>
  */
  {
    "id": "aQF57OMa",
    "block": "[[[10,0],[15,0,[29,[\"cPV--listPanel \",[52,[30,0,[\"hasEditedPosts\"]],\"has--changes\",\"\"]]]],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n    \"],[10,\"li\"],[14,0,\"cPV--list__li u--text--left\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"postScheduleTitle\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.post_schedule\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[10,2],[14,0,\"u--text--sm u--m__0\"],[14,\"data-test-id\",\"dragMediaMessage\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"preview_grid.can_schedule_message\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"          \"],[10,0],[14,0,\"cIC--card\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"cIC--cardBody u--p__sm\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"preview_grid.reels.can_schedule_message\"],null]],[1,\"\\n              \"],[8,[39,2],null,[[\"@route\"],[\"index\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,1],[\"preview_grid.reels.can_schedule_message_action\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]],null]],[]]]],[]],[[[41,[30,0,[\"canCreateTimeSlots\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.setup_quick_schedule_title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--sm u--m__b\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.setup_quick_schedule_info\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,3],[[24,\"data-test-id\",\"quickScheduleButton\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,4],[28,[37,1],[\"preview_grid.setup_quick_schedule\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"previewGridTitle\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.preview_posts\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--sm u--m__0\"],[14,\"data-test-id\",\"cannotScheduleMsg\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.cannot_schedule_message\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasEditablePosts\"]],[[[42,[28,[37,5],[[28,[37,5],[[30,0,[\"sortedEditablePosts\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[15,0,[29,[\"cPV--list__li \",[52,[30,5,[\"hasBeenEdited\"]],\"has--changes\",\"\"]]]],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"cPV--list__img u--inline\"],[15,\"src\",[30,5,[\"secureImageUrl\"]]],[12],[13],[1,\"\\n\"],[41,[30,5,[\"isDraftPost\"]],[[[1,\"            \"],[10,1],[14,0,\"cPV--list__label--draft\"],[12],[1,\"\\n              \"],[1,[28,[35,6],[\"draft-post\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_words.draft\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,0],[14,0,\"cPV--list__content\"],[12],[1,\"\\n\"],[41,[30,5,[\"isRemoved\"]],[[[1,\"              \"],[10,0],[14,0,\"cPV--list__undo\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"preview_grid.post_unscheduled\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[8,[39,3],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--text--sm u--text--uppercase u--p__r__0 u--text--hl\",[28,[37,7],[[30,0,[\"undoRemovePreviewPost\"]],[30,5]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,6],[\"undo\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n                  \"],[8,[39,8],null,[[\"@delay\",\"@side\"],[330,\"left\"]],[[\"default\"],[[[[1,\"\\n                    \"],[10,1],[12],[1,[28,[35,1],[\"preview_grid.undo\"],null]],[13],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,5,[\"hasScheduledTime\"]],[[[1,\"              \"],[10,1],[14,0,\"u--block u--text--sm\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[30,5,[\"scheduledMoment\"]],\"MMM DD h:mm a, YYYY\",[30,0,[\"timeZoneIdentifier\"]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[51,[30,5,[\"socialProfile\",\"hasPublishingMethod\"]]],[[[1,\"                \"],[10,1],[14,0,\"u--block u--text--sm\"],[12],[1,[28,[35,1],[\"preview_grid.non_published_post\"],null]],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"              \"],[10,1],[14,0,\"u--block u--text--sm\"],[12],[1,[28,[35,1],[\"preview_grid.to_be_auto_scheduled\"],null]],[13],[1,\"\\n            \"]],[]]]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[5]],null]],[]],[[[1,\"      \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n        \"],[10,2],[14,\"data-test-id\",\"noScheduledPostsMsg\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"preview_grid.empty_list\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@enableAutoSchedule\",\"@isFeedTab\",\"@isReelsTab\",\"@showQuickScheduleWizard\",\"post\"],false,[\"if\",\"t\",\"link-to\",\"shared/ui/button\",\"each\",\"-track-array\",\"svg-jar\",\"fn\",\"ember-tooltip\",\"moment-format\",\"unless\"]]",
    "moduleName": "preview-grid/components/post-schedule-sidebar.hbs",
    "isStrictMode": false
  });

  let PostScheduleSidebarComponent = (_class = class PostScheduleSidebarComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "userConfig", _descriptor, this);

      if (!args.previewPosts) {
        throw new Error('PostScheduleSidebarComponent requires a `previewPosts` argument');
      }
    }

    get timeZoneIdentifier() {
      return this.userConfig.currentTimeZone?.identifier;
    }

    get canCreateTimeSlots() {
      return !this.args.hasTimeSlots;
    }

    get hasEditablePosts() {
      return this.editablePosts.length > 0;
    }

    get hasEditedPosts() {
      return this.editedPosts.length > 0;
    }

    get editablePosts() {
      return this.args.previewPosts.filter(post => post.canMove) || [];
    }

    get editedPosts() {
      return this.args.previewPosts.filter(post => post.hasBeenEdited) || [];
    }

    get sortedEditablePosts() {
      return this.editablePosts.slice().sort((a, b) => b.queueOrder - a.queueOrder);
    }

    undoRemovePreviewPost(previewPost) {
      (0, _object.set)(previewPost, 'isRemoved', false);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "undoRemovePreviewPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "undoRemovePreviewPost"), _class.prototype)), _class);
  _exports.default = PostScheduleSidebarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostScheduleSidebarComponent);
});